import React from "react";
import { NavLink } from "react-router-dom";
import { visibleAdminNavItems } from "@/lib/adminNavigation";
import { useApp } from "@/context/AppContext";

export default function Sidebar() {
  const { currentAdmin } = useApp();
  const items = visibleAdminNavItems(currentAdmin?.permissions);
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex w-64 fixed inset-y-0 left-0 z-40 flex-col text-[#E0F2E9]"
      style={{ background: "linear-gradient(180deg, #0E5B52 0%, #0A4640 100%)" }}
    >
      {/* Brand */}
      <div className="h-16 px-5 border-b border-white/10 flex items-center">
        <div className="flex items-center gap-2.5 rounded-2xl bg-white/6 px-2.5 py-1.5 w-full">
          <div className="h-9 w-9 rounded-xl bg-white flex items-center justify-center shadow-[0_8px_20px_rgba(0,0,0,0.14)]">
            <img
              src="/shopbook-logo.png"
              alt="Shopbook"
              className="block h-9 w-9 object-contain"
              loading="eager"
            />
          </div>
          <div className="min-w-0">
            <div className="font-display text-[14px] font-semibold text-white leading-none truncate">Shopbook</div>
            <div className="text-[8px] tracking-[0.18em] uppercase text-[#A7F3D0]/80 mt-0.5 truncate">Ops Console</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-2.5 py-3 space-y-px overflow-y-auto">
        <div className="px-2.5 py-1.5 text-[9px] tracking-[0.18em] uppercase text-white/40">Operations</div>
        {items.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `group flex items-center gap-2.5 px-2.5 py-2 rounded-md text-[13px] font-medium transition-all ${
                isActive
                  ? "bg-white/10 text-white"
                  : "text-white/70 hover:bg-white/5 hover:text-white"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`w-[3px] h-4 rounded-full ${isActive ? "bg-[#FDE047]" : "bg-transparent"}`} />
                <Icon className="w-4 h-4" strokeWidth={2} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-3 m-2.5 rounded-lg bg-white/5 border border-white/10">
        <div className="text-[9px] uppercase tracking-[0.14em] text-[#A7F3D0]">Admin session</div>
        <div className="mt-1 flex items-center gap-1.5 text-[13px] font-medium text-white">
          <span className="w-1.5 h-1.5 rounded-full bg-[#A7F3D0]" />
          Connected securely
        </div>
        <div className="text-[10px] text-white/50 mt-0.5">HttpOnly session protection</div>
      </div>
    </aside>
  );
}
